<template>
  <div class="the-sidebar">
    <a href="/" class="logo">
      <img src="../../assets/logo.png" alt="">
      <span>Менеджер<span>старый</span></span>
    </a>
    <div class="menu" v-if="menu">
      <div class="menu-name">{{ menu.name }}</div>

      <div v-for="(item, i) in menu.items" :key="'menu-item-' + i">
        <!-- DIVIDE -->
        <div v-if="item.type === 'divide'" class="menu-divide"></div>

        <!-- SIMPLE MENU LINK -->
        <div v-if="(item.type === 'link' || item.type === 'custom-link') && item.show">
          <router-link class="menu-item" :to="{ name: item.comp }">
            <div v-if="item.icon" class="menu-item-icon">
              <VIcon :name="item.icon"/>
            </div>
            <div v-else-if="item.iconClass" class="menu-item-icon">
              <div :class="item.iconClass"></div>
            </div>
            <div v-if="item.name" class="menu-item-name">
              {{ item.name }}
            </div>
          </router-link>
        </div>

        <!-- MENU LINK WITH BUTTON MENU -->
        <div v-if="item.type === 'menu' && item.show">
          <router-link class="menu-item" :to="{ name: item.comp }" @click="item.collapse = true">
            <div v-if="item.icon" class="menu-item-icon">
              <VIcon :name="item.icon"/>
            </div>
            <div v-else-if="item.iconClass" class="menu-item-icon">
              <div :class="item.iconClass"></div>
            </div>
            <div v-if="item.name" class="menu-item-name">
              <b>{{ item.name }}</b>
            </div>
            <div class="menu-item-button-right" @click.prevent.stop="item.collapse = !item.collapse">
              <VIcon v-if="!item.collapse" name="cisMenu" size="sm"/>
              <VIcon v-else name="cisMenu" size="sm"/>
            </div>
          </router-link>

          <!-- MENU LINK ITEMS -->
          <div v-if="!item.collapse" class="menu-group">
            <div v-for="(menu, m) in item.items" :key="'in-menu-'+m">
              <router-link class="menu-item" :to="{ name: menu.comp }">
                <div v-if="menu.icon" class="menu-item-icon">
                  <VIcon :name="menu.icon"/>
                </div>
                <div v-else-if="item.iconClass" class="menu-item-icon">
                  <div :class="item.iconClass"></div>
                </div>
                <div v-if="menu.name" class="menu-item-name">
                  {{ menu.name }}
                </div>
              </router-link>
            </div>
          </div>
        </div>

        <!-- MENU GROUP -->
        <div v-if="item.type === 'group' && item.show">
          <div class="menu-item" @click="item.collapse = !item.collapse">
            <div v-if="item.icon" class="menu-item-icon">
              <VIcon :name="item.icon"/>
            </div>
            <div v-else-if="item.iconClass" class="menu-item-icon">
              <div :class="item.iconClass"></div>
            </div>
            <div v-if="item.name" class="menu-item-name">
              <b>{{ item.name }}</b>
            </div>
            <div class="menu-item-icon-right">
              <div class="arr" :class="{ 'arr-open': !item.collapse}"></div>
            </div>
          </div>

          <!-- MENU GROUP ITEMS -->
          <div v-if="!item.collapse" class="menu-group">
            <div v-for="(groupItem, g) in item.items" :key="'g-item-'+g">
              <router-link class="menu-item" :to="{ name: groupItem.comp }" v-if="groupItem.show">
                <div v-if="groupItem.icon" class="menu-item-icon">
                  <VIcon :name="groupItem.icon"/>
                </div>
                <div v-else-if="groupItem.iconClass" class="menu-item-icon">
                  <div :class="groupItem.iconClass"></div>
                </div>
                <div v-if="groupItem.name" class="menu-item-name">
                  {{ groupItem.name }}
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="menu-name">
      Добро пожаловать!
    </div>
  </div>
</template>

<script>
import VIcon from '@/base/components/icon/VIcon'
import { useMenu } from '@/base/use/menu'

export default {
  name: 'Menu',
  components: { VIcon },
  setup () {
    const { menu } = useMenu()
    return {
      menu
    }
  }
}
</script>

<style lang="scss" scoped>
.the-sidebar {
  display: flex;
  flex-direction: column;
  background-color: #eef2f4;
  height: 100vh;
  -moz-user-select: none;
  user-select: none;

  .logo {
    display: flex;
    height: 49px;
    background-color: #535c69;
    padding-left: 12px;
    img {
      width: 40px;
      height: 40px;
      margin: 5px 15px 5px 0;
    }
    span {
      font-size: 22px;
      line-height: 49px;
      color: white;
      font-weight: bold;
      font-family: "OpenSans-Semibold", sans-serif;
      font-variant: small-caps;
      span {
        font-size: 22px;
        color: orange;
        margin-left: 4px;
      }
    }
  }

  .menu {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .menu-welcome {
    width: 100%;
    height: 49px;
    text-decoration: none;
    text-align: center;
    padding-top: 14px;
    border-bottom: 1px solid #ccc;
    font-size: .8rem;
  }

  .arr {
    background-image: url(data:image/png;base64,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);
    transform: rotate(180deg);
    width: 16px;
    height: 16px;
    background-size: contain;
    margin: 12px;
  }

  .arr-open {
    transform: rotate(90deg);
  }

  .menu-name {
    display: flex;
    width: 100%;
    height: 49px;
    line-height: 49px;
    color: #535c69 !important;
    padding-left: 13px;
    font-weight: 700;
    border-bottom: 1px solid #ccc;
    text-align: center;
    text-transform: uppercase;
  }

  .menu-group {
    border-left: 4px solid #535c69;
  }

  .menu-item {
    position: relative;
    display: flex;
    width: 100%;
    height: 40px;
    color: #535c69;
    text-decoration: none;
    cursor: pointer;
    font: 14px "Helvetica Neue", Arial, Helvetica, sans-serif;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    white-space: nowrap;

    &:hover, &:active {
      background-color: #e6eaed;
    }
  }

  .menu-divide {
    position: relative;
    display: flex;
    height: 1px;
    background-color: #ccc;
  }

  .active {
    background-color: #535c69;
    color: #fff;
    &:hover {
      background-color: #535c69;
      color: #fff;
      cursor: default;
    }
  }

  .menu-item-icon {
    min-width: 50px;
    height: 40px;
    line-height: 38px;
    text-align: center;
  }

  .menu-item-icon-right {
    min-width: 40px;
    height: 40px;
    line-height: 35px;
    text-align: center;
    opacity: .5;
  }

  .menu-item-button-right {
    min-width: 40px;
    height: 40px;
    line-height: 37px;
    text-align: center;
    &:hover {
      cursor: pointer;
      color: #fff;
      background-color: #535c69;
    }
  }

  .menu-item-name {
    width: 100%;
    height: 40px;
    line-height: 41px;
    font-size: 15px;
  }

  .menu-item-sub-name {
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    font-weight: 700;
  }

  .version-link {
    color: gray;
    background-color: transparent;
    &:hover {
      color: #009df1;
      cursor: pointer;
      background-color: transparent;
    }
    &:active {
      color: gray;
      background-color: transparent;
    }
  }
}
</style>
